import { setLocalStorageItem } from "../../../../../hooks/localStorageHooks";
import storeApi from "../../../../../services/api/Store";
import { IStore } from "../../../../../services/api/Store/types";

export const handleSelectStore = (store: IStore) =>
  setLocalStorageItem("selectedStore", store);

export const handleDeleteStore = async (store: IStore, confirmMessage: string) => {
  if (window.confirm(confirmMessage)) {
    try {
      await storeApi.deleteStore(store.id);
    } catch (error) {
      console.error("Error deleting the store: ", error);
    }
  }
};
